import { Controller } from "stimulus"

class MultiTabsController extends Controller {
  initialize() {
    const tabLists = document.querySelectorAll('.n-tab');
    tabLists.forEach(tabList => {
      const tabItems = tabList.querySelectorAll('.tab-item');
      const tabContents = tabList.querySelectorAll('.n-tab-content');
      tabItems.forEach(tabItem => {
        const tab = tabItem.dataset.multiTabsTarget;
        if (!tab) {
          tabItem.remove();
          return;
        }

        tabItem.addEventListener('click', function () {
          tabItems.forEach(t => {
            t.dataset.multiTabsTarget == tab ? t.classList.add('selected') : t.classList.remove('selected')
          });

          tabContents.forEach(t => {
            t.id == tab ? t.classList.add('selected') : t.classList.remove('selected')
          });
        });
      });
    });
  }
}

export default MultiTabsController;
